import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.CoreDialog, {
    attrs: {
      size: "sm",
      "data-qa": "registration-error-modal",
      title: _setup.t(_setup.title || "Ошибка", _setup.options),
    },
    scopedSlots: _vm._u(
      [
        _setup.message
          ? {
              key: "default",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "text-body-1 text-secondary--text" },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_setup.t(_setup.message, _setup.options)) +
                          "\n    "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            }
          : null,
        {
          key: "actions",
          fn: function () {
            return [
              _c(
                VBtn,
                {
                  attrs: {
                    "data-qa": "modal-actions-btn-close",
                    color: "primary",
                    text: "",
                  },
                  on: {
                    click: function ($event) {
                      _setup.isOpened = false
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_setup.t("Понятно", _setup.options)) +
                      "\n    "
                  ),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
    model: {
      value: _setup.isOpened,
      callback: function ($$v) {
        _setup.isOpened = $$v
      },
      expression: "isOpened",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }